export default function Modal({ title, children, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="login-card modal-card">
        <div className="header">
          <h3 style={{ color: "#333" }}>{title}</h3>
          <button onClick={onClose} className="close-btn">✕</button>
        </div>

        {children}
      </div>
    </div>
  );
}